import { configureStore } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";

import persistedReducer from "redux/reducers/rootReducer";

import crashReporter from "../middleware/crashReporter";
import { listenerMiddleware } from "../middleware/listenerMiddleware";
import logoutMiddleware from "../middleware/logoutMiddleware";
import routerMiddleware from "../middleware/router";

export type TCreateAppStoreOptions = {
  devTools: boolean;
};

/**
 * Application store and persistor.
 * Middleware runs as crashReporter, listener, thunk, router, then logout.
 * Toolkit checks stay off so existing reducers and redux-persist keep working.
 */
export function createAppStore(
  preloadedState?: object,
  { devTools }: TCreateAppStoreOptions = { devTools: false },
) {
  const store = configureStore({
    reducer: persistedReducer,
    preloadedState,
    devTools,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
        actionCreatorCheck: false,
      })
        .concat(routerMiddleware, logoutMiddleware)
        .prepend(crashReporter, listenerMiddleware.middleware),
  });

  const persistor = persistStore(store);

  return { store, persistor };
}
